import { useStoreActions, useStoreState } from '@/stores/store';

export function useSelectExerciseState() {
  const addTask = useStoreActions((actions) => actions.addTask);
  const copySettings = useStoreActions((actions) => actions.copySettings);

  const resetExercisesState = useStoreActions(
    (actions) => actions.resetExercisesState,
  );

  const chosenTasks = useStoreState(
    (state) => state.chosenTasks,
    // eslint-disable-next-line
    (prev, next) => {}, // dont remove it, it will break select exercises
  );

  const patient = useStoreState((state) => state.patient);
  const chosenSets = useStoreState((state) => state.chosenSets);
  const appType = useStoreState((state) => state.appType);

  return {
    addTask,
    copySettings,
    resetExercisesState,
    chosenTasks,
    patient,
    chosenSets,
    appType,
  };
}
